export class AutoSendPeppolSettings {
	SendSales:boolean = false;
	SendSalesFromDate:Date | null = null;

	public constructor(data?:any) {
		if (!data) return;
		this.SendSales = data.SendSales || false;
		if (data.SendSalesFromDate) {
			this.SendSalesFromDate = new Date(data.SendSalesFromDate);
		}
	}
}
